import React, { useEffect, useState } from "react";
import { Drawer, notification, Checkbox, Row, Col } from "antd";
import { RollbackOutlined, KeyOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import CustomScrollbars from "util/CustomScrollbars";

import ContactList from "components/contact/ContactList";
import RequestHandler from "../../util/RequestHandler";

const UserAccountRoles = (props) => {
  const history = useHistory();
  const [bankListForTRY, setBankListForTRY] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [drawerState, setDrawerState] = useState(false);
  const [isFullAccountChecked, setIsFullAccountChecked] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [checkboxDisabled, setCheckboxDisabled] = useState(false);

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Hesap yetkilendirme işlemi başarılı!',
      duration: 2,
    });
  };

  const onContactSelect = (value) => {
    RequestHandler.post(`/User/AddFullAccountAuth`, { userId: props.match.params.userId }, false, { rawResponse: true }).then(res => {
      if (res.status == 200) {
        setIsFullAccountChecked(res.data.data.isFullAccountAuth)
        openNotificationWithIcon('success');
        setDisabled(res.data.data.isFullAccountAuth)
      }
    });
  };

  const onToggleDrawer = () => setDrawerState(true);

  const onToggleDrawerClose = () => setDrawerState(false);

  const getComp = (val) => {
    RequestHandler.post(`/TenantAccount/GetWithTenantAccountUser`, {
      tenantId: localStorage.getItem("tenantId"),
      userId: props.match.params.userId,
      bankId: val
    }, false).then(response => {
      setContactList(response);
    });
  }

  useEffect(() => {
    RequestHandler.get(`/User/IsAdmin?userId=${props.match.params.userId}`).then(response => {
      setDisabled(response);
      setCheckboxDisabled(response);
    });

    RequestHandler.post(`/User/IsFullAccountAuth`, { userId: props.match.params.userId }, false).then(response => {
      setIsFullAccountChecked(response.data);
      setDisabled(response.data);
    });

    RequestHandler.get(`/TenantAccount?$apply=groupby((BankLogo,BankId,BankCode),aggregate(Balance with sum as Balance))`).then(response => {
      setBankListForTRY(response);
    });
  }, [setIsFullAccountChecked, setDisabled]);

  const goBankAccount = (value) => {
    RequestHandler.post(`/TenantAccount/GetWithTenantAccountUser`, {
      tenantId: localStorage.getItem("tenantId"),
      userId: props.match.params.userId,
      bankId: value
    }, false).then(response => {
      setContactList(response);
    });
  }

  const ContactSideBar = () => {
    return <div style={disabled ? { pointerEvents: "none", opacity: "0.4" } : {}} className="gx-module-side">
      <div className="gx-module-side-header">
        <div className="gx-module-logo">
          <span>Kullanıcı Hesap Yetkileri </span>
        </div>
      </div>

      <div className="gx-module-side-content">

        <CustomScrollbars className="gx-module-side-scroll">
          <div className="gx-module-add-task">

          </div>
          <div className="gx-module-side-nav">
            <ul className="gx-module-nav">
              {bankListForTRY.map(option =>
                <li key={option.bankId} className="gx-nav-item" onClick={() => goBankAccount(option.bankId)}>
                  <span
                    className={`gx-link`} >
                    <img style={{ width: '80%' }} src={option.bankLogo}  ></img>
                  </span>
                </li>
              )}

            </ul>
          </div>
        </CustomScrollbars>
      </div>
    </div>

  };

  return (
    <div>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}><a onClick={() => history.goBack()} style={{ color: 'black', marginLeft: "4%" }}> <RollbackOutlined /> GERİ DÖN</a></Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col flex={1}> <p style={{ fontSize: '200%', marginLeft: "4%" }}><KeyOutlined /> HESAP YETKİLENDİRME</p><hr></hr><br></br></Col>
        <Col flex={4}></Col>
      </Row>
      <div className="gx-main-content">
        <div className="gx-app-module">
          <div className="gx-d-block gx-d-lg-none">
            <Drawer
              placement="left"
              width={100}
              closable={false}
              visible={drawerState}
              onClose={onToggleDrawerClose}>
              {ContactSideBar()}
            </Drawer>
          </div>
          <div className="gx-module-sidenav gx-d-none gx-d-lg-flex">
            {ContactSideBar()}
          </div>

          <div className="gx-module-box">
            <div className="gx-module-box-header">
              <span className="gx-drawer-btn gx-d-flex gx-d-lg-none">
                <i className="icon icon-menu gx-icon-btn" aria-label="Menu"
                  onClick={onToggleDrawer} />
              </span>
            </div>
            <div className="gx-module-box-content">

              <div className="gx-module-box-topbar">
                <Checkbox className="gx-icon-btn"
                  checked={isFullAccountChecked}
                  value="checkedF"
                  disabled={checkboxDisabled}
                  onClick={() => onContactSelect()} /> <p>Tüm Yetkiler</p>
              </div>
              <CustomScrollbars className="gx-module-content-scroll">
                {contactList.length === 0 ?
                  <div className="gx-h-100 gx-d-flex gx-align-items-center gx-justify-content-center">
                    Lütfen bir banka seçiniz
                  </div>
                  : <ContactList disabledPage={isFullAccountChecked} getDataComp={getComp} userId={props.match.params.userId} contactList={contactList} />
                }
              </CustomScrollbars>

            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default UserAccountRoles;
